import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/post/admin/circles/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/post/admin/circles',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/post/admin/circles/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/post/admin/circles/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/post/admin/circles',
    method: 'put',
    data: obj
  })
}

export function setPublic(id) {
  return request({
    url: '/post/admin/circles/public/' + id,
    method: 'put'
  })
}

export function setActive(id) {
  return request({
    url: '/post/admin/circles/active/' + id,
    method: 'put'
  })
}

export function fetchMemberList(query, id) {
  return request({
    url: `/post/admin/circles/${id}/members/page`,
    method: 'get',
    params: query
  })
}

export function fetchNoticeList(query, id) {
  return request({
    url: `/post/admin/circles/${id}/notices/page`,
    mehod: 'get',
    params: query
  })
}

export function switchNoticeStatus(circleId, noticeId, isActive) {
  return request({
    url: `/post/admin/circles/${circleId}/notices/${noticeId}/${isActive}`,
    method: 'put'
  })
}

export function fetchTagList(id) {
  return request({
    url: `/post/admin/circles/${id}/tags`,
    method: 'get'
  })
}

export function updateCircleTags(id, tags) {
  return request({
    url: `/post/admin/circles/${id}/tags`,
    method: 'put',
    data: tags
  })
}

export function fetchIndustryList(id) {
  return request({
    url: `/post/circles/${id}/industries`,
    method: 'get'
  })
}

export function updateCircleSort(query) {
  return request({
    url: `/post/admin/circles/${query.circleId}/sort`,
    method: 'PUT',
    data: query
  })
}


export function getCirclesAdmin(query) {
  return request({
    url: `/post/admin/circles/query`,
    method: 'GET',
    params: query
  })
}

export function getAllCircleMembersAdmin(query) {
  return request({
    url: `/post/admin/circles/${query.circleId}/members/query`,
    method: 'GET',
    params: query
  })
}

export function getCircleNames() {
  return request({
    url: '/post/admin/circles/circle-names',
    method: 'GET'
  })
}

export function getTagsByType(type) {
  return request({
    url: `/post/admin/circles/group/type/${type}`,
    method: 'GET'
  })
}
